import PropTypes from 'prop-types';
import { SectionStyles } from '../styles';

const ICON_MAP = {
  address: '/icons/location.png',
  phone: '/icons/phone.png',
  email: '/icons/email.png',
  web: '/icons/web.png',
};

function ContactItem({ icon, label, value, href }) {
  if (!value) return null;
  const content = href ? (
    <a href={href} target="_blank" rel="noopener noreferrer">
      {value}
    </a>
  ) : (
    value
  );
  return (
    <div className="contact-item">
      <img src={icon} alt="" className="contact-icon" />
      <div className="contact-content">
        <span className="contact-label">{label}</span>
        <span className="contact-value">{content}</span>
      </div>
    </div>
  );
}

ContactItem.propTypes = {
  icon: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  href: PropTypes.string,
};

ContactItem.defaultProps = {
  value: '',
  href: null,
};

function Contact({ company }) {
  const website =
    company?.website?.startsWith?.('http')
      ? company.website
      : company?.website
        ? `https://${company.website}`
        : '';

  return (
    <SectionStyles id="contact" className="section-contact">
      <div className="section-inner">
        <h2 className="section-title">Liên hệ</h2>
        <div className="contact-grid">
          <ContactItem
            icon={ICON_MAP.address}
            label="Địa chỉ"
            value={company?.address}
          />
          <ContactItem
            icon={ICON_MAP.phone}
            label="Điện thoại"
            value={company?.phoneNumber}
          />
          <ContactItem
            icon={ICON_MAP.email}
            label="Email"
            value={company?.email}
            href={company?.email ? `mailto:${company.email}` : null}
          />
          <ContactItem
            icon={ICON_MAP.web}
            label="Website"
            value={company?.website}
            href={website || null}
          />
        </div>
      </div>
    </SectionStyles>
  );
}

Contact.propTypes = {
  company: PropTypes.shape({
    address: PropTypes.string,
    phoneNumber: PropTypes.string,
    email: PropTypes.string,
    website: PropTypes.string,
  }),
};

Contact.defaultProps = {
  company: null,
};

export default Contact;
